import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = {
  class: "page-header",
  style: {"text-align":"center"}
}
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "page-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_RegistrationAgent = _resolveComponent("RegistrationAgent")!

  return (_openBlock(), _createElementBlock("div", {
    id: "landing-page__addOffer",
    class: _normalizeClass([_ctx.competition ? _ctx.uniqueClass : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: { name: 'AdSearch' },
              custom: ""
            }, {
              default: _withCtx(({ href }) => [
                _createElementVNode("a", {
                  href: href,
                  id: "header-logo",
                  style: {"display":"inline-block"}
                }, [
                  _createElementVNode("img", {
                    src: _ctx.logoUrl,
                    width: "270",
                    height: "47",
                    alt: _ctx.domain + ' logo'
                  }, null, 8, _hoisted_6)
                ], 8, _hoisted_5)
              ]),
              _: 1
            }),
            _createElementVNode("h1", {
              innerHTML: _ctx.$t('RegistrationAgentCompetition.competition-header.' + _ctx.competition.id)
            }, null, 8, _hoisted_7)
          ]),
          _createVNode(_component_ResizableImage, {
            url: _ctx.competition.image,
            width: 1104,
            height: 743,
            alt: "award"
          }, null, 8, ["url"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_RegistrationAgent, {
          isCompetition: true,
          competition: _ctx.competition.id,
          competitionTermsUrl: _ctx.competition.termsUrl
        }, null, 8, ["competition", "competitionTermsUrl"])
      ])
    ])
  ], 2))
}